export default class Http {
    static get apiHost() {
        return this._apiHost;
    }

    static set apiHost(value) {
        this._apiHost = value;
    }

    static _apiHost = "";
    static http() {
        const root = document.getElementById("root");
        // this.apiHost = root.getAttribute("data-api-host")
        this.apiHost = ''
    }
}